import { HIDE_CLASS } from './utils';

function getAddressBookFormWrapper(): HTMLElement | null {
  return document.querySelector<HTMLElement>('.js-address-form');
}

function bindAddNewAddress(): void {
  const addressBookForm = getAddressBookFormWrapper();

  if (!addressBookForm) {
    return;
  }

  const addButton = document.querySelector<HTMLElement>('.js-add-new-address');

  addButton?.addEventListener('click', (e) => {
    e.preventDefault();
    (
      addressBookForm.querySelector(
        'input:not([name$=firstName]):not([name$=lastName]):not([name$=phone])'
      ) as HTMLInputElement
    ).value = '';
    addressBookForm.classList.remove(HIDE_CLASS);
    addButton.classList.add(HIDE_CLASS);
  });
}

export function handleEnterManualAddress(enterManualAddressCTA: HTMLElement): void {
  const addressBookForm = getAddressBookFormWrapper();

  if (!addressBookForm) {
    return;
  }

  const fields = addressBookForm.querySelectorAll<HTMLElement>('.manual-address');
  fields.forEach((field: HTMLElement) => {
    field.classList.remove(HIDE_CLASS);
  });

  enterManualAddressCTA.classList.add(HIDE_CLASS);

  const postcodeInputEl = addressBookForm.querySelector<HTMLInputElement>('.js-postcode-input');
  const postcodeSearchEl = addressBookForm.querySelector<HTMLElement>('.postcode-search');
  const submitEl = addressBookForm.querySelector<HTMLElement>('.address-form__submit');

  if (postcodeInputEl) {
    postcodeInputEl.value = '';
  }

  if (postcodeSearchEl) {
    postcodeSearchEl.classList.add(HIDE_CLASS);
  }

  if (submitEl) {
    submitEl.classList.remove(HIDE_CLASS);
  }
}

function handleUsePostcodeLookup(postocodeLookupCTA: HTMLElement): void {
  const addressBookForm = getAddressBookFormWrapper();

  if (!addressBookForm) {
    return;
  }

  const fields = addressBookForm.querySelectorAll<HTMLInputElement>('.manual-address');

  fields.forEach((field) => {
    field.classList.add(HIDE_CLASS);
    field.querySelectorAll<HTMLInputElement>('input').forEach((e) => {
      e.value = '';
    });
  });

  addressBookForm.querySelectorAll<HTMLElement>('.js-edit-address-manually').forEach((el) => {
    el.classList.remove(HIDE_CLASS);
  });

  postocodeLookupCTA.classList.add(HIDE_CLASS);

  const submitEl = addressBookForm.querySelector<HTMLElement>('.address-form__submit');

  if (submitEl) {
    submitEl.classList.add(HIDE_CLASS);
  }

  const postcodeInputEl = addressBookForm.querySelector<HTMLInputElement>('#address.postcodeLookup');

  if (postcodeInputEl) {
    postcodeInputEl.value = '';
    postcodeInputEl.blur();
  }

  const postcodeSearchEl = addressBookForm.querySelector<HTMLElement>('.postcode-search');

  if (postcodeSearchEl) {
    postcodeSearchEl.classList.remove(HIDE_CLASS);
  }
}

function bindEnterManualAddress(): void {
  const addressBookForm = getAddressBookFormWrapper();

  if (!addressBookForm) {
    return;
  }

  const editAddressManuallyButton = addressBookForm.querySelector<HTMLElement>('.js-edit-address-manually');

  if (editAddressManuallyButton) {
    editAddressManuallyButton.addEventListener('click', (e) => {
      e.preventDefault();
      handleEnterManualAddress(editAddressManuallyButton);
    });
  }
}

function bindUsePostcodeLookup(): void {
  const addressBookForm = getAddressBookFormWrapper();

  if (!addressBookForm) {
    return;
  }

  const usePostcodeBtn = addressBookForm.querySelector<HTMLElement>('.js-use-postcode-lookup');

  if (usePostcodeBtn) {
    usePostcodeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      handleUsePostcodeLookup(usePostcodeBtn);
    });
  }
}

function isNotMandatory(countryIsoCode): boolean {
  const notMandatoryPostCodeCountries = ['IE'];
  return !!notMandatoryPostCodeCountries.find((el) => el === countryIsoCode);
}

function checkMandatoryPostcode(countryIsoCode): void {
  const addressBookForm = getAddressBookFormWrapper();

  if (!addressBookForm) {
    return;
  }

  const input = addressBookForm.querySelector<HTMLInputElement>('#address.postcode');

  if (!input) {
    return;
  }

  const label = input.parentElement?.querySelector<HTMLElement>('label');

  if (!label) {
    return;
  }

  if (isNotMandatory(countryIsoCode)) {
    input.removeAttribute('required');
    input.classList.remove('required');
    label.innerText = 'Eircode (Enter if known)';
  } else {
    input.setAttribute('required', 'required');
    input.classList.add('required');
    label.innerText = 'Postcode';
  }
}

function bindUpdateCountrySelectedIsoCode(): void {
  const addressBookForm = getAddressBookFormWrapper();

  if (!addressBookForm) {
    return;
  }

  const countryIsoSelect = addressBookForm.querySelector<HTMLInputElement>('#address.country');

  if (!countryIsoSelect) {
    return;
  }
  if (countryIsoSelect.value) {
    checkMandatoryPostcode(countryIsoSelect.value);
  }
  countryIsoSelect.addEventListener('change', () => {
    const countrySelectedIsoCode = countryIsoSelect.value;
    checkMandatoryPostcode(countrySelectedIsoCode);
  });
}

function initAddressForm(): void {
  bindAddNewAddress();
  bindEnterManualAddress();
  bindUsePostcodeLookup();
  bindUpdateCountrySelectedIsoCode();
}
export default initAddressForm;
